<template>
  <div class="agreement agreement--left" :class="wrapperClasses">
    <BaseLabel
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    >
      <BaseAgreement
        :id="id"
        v-model="data"
        :disabled="disabled"
        @input="emitEvent"
      ></BaseAgreement>
      <span v-html="label"></span>
      <a
        v-if="fullText"
        href="#"
        class="agreement__toggle"
        @click.prevent="toggle()"
      >
        <template v-if="revealed">{{ hideText }}</template>
        <template v-if="!revealed">{{ revealText }}</template>
      </a>
    </BaseLabel>

    <div v-if="description || error" :class="descriptionClasses">
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
    <transition name="slide-fade">
      <div
        v-show="revealed"
        class="agreement__full-text"
        :class="descriptionClasses"
      >
        {{ fullText }}
      </div>
    </transition>
  </div>
</template>

<script>
import AgreementControl from "./AgreementControl";

export default {
  name: "AgreementControl",
  extends: AgreementControl,
  data() {
    return {
      controlOptions: {
        labelClass: "form__label",
        inlineLabelClass: "col-form-label col-sm-10 form__label",
        controlClass: "form__control",
        inlineControlClass: "col-sm-2 form__control",
        descriptionClass: "form__control-description",
        inlineDescriptionClass: "col-sm-10 form__control-description"
      }
    };
  }
};
</script>

<style lang="scss">
.agreement--left {
  .form__label-text {
    display: block;
    position: relative;
    padding-left: 2em;
  }
  .custom-checkbox {
    position: absolute;
    left: 0;
    top: -0.1em;
  }
  .custom-control-label {
    float: none !important;
  }
}
</style>
